import { UserAvatarViewStore } from 'common/module/user/avatar/view-store';
import { UserAvatarViewStoreFactory } from 'common/module/user/avatar/view-store.factory';

const view = UserAvatarViewStoreFactory();
view.initialize({ willFetchSavedSearches: true });

export function UserAvatarService(): UserAvatarViewStore {
  return view;
}
